<div class="product-card">
    <div class="product-card-body">
        <!-- product image section-->
        <div class="image-container">
            @if (hasFeaturedImages()) {
                <img [src]="firstImageUrl()" class="item-image" />
            } @else {
                <img [src]="IMAGE_URLS.noImagePlaceholder" class="item-image" />
            }
        </div>

        <!-- product title and price section-->
        <div class="product-content" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
            <!-- product title -->
            <p class="product-title text-control">
                {{ product.name }}
            </p>

            <div class="product-price d-flex">
                @if (hasDiscount()) {
                    <span class="selling-price">{{ sellingPrice() | indianCurrency }}</span>
                    <span class="actual-price">{{ actualPrice() | indianCurrency }}</span>
                } @else {
                    <span class="product-price">{{ sellingPrice() | indianCurrency }}</span>
                }
            </div>
            <!-- variants -->
            <!-- <p class="variants">Variant: {{ product.variant }}</p> -->
        </div>
    </div>
</div>